import { useQuery } from "@tanstack/react-query";

import { apiFetch, buildParams } from "@/lib/api";
import { shouldUseHomeMockFallback } from "@/lib/devMockFallback";
import { homeQueryKeys } from "@/lib/homeQueryCache";
import { getMockAviList } from "@/mocks";
import type { AviListParams, PaginatedAviListOutput } from "@/types";

export async function fetchAviList(params: AviListParams) {
  const query = buildParams({
    account_id: params.account_id,
    role: params.role,
    search: params.search,
    match_mode: params.match_mode,
    pillar: params.pillar,
    project_id: params.project_code,
    site_name: params.site_name,
    asset_names: params.asset_names,
    standard_acronym: params.standard_acronym,
    workflow_status: params.workflow_status,
    deadline_status: params.deadline_status,
    due_date_from: params.due_date_from,
    due_date_to: params.due_date_to,
    sort_dir: params.sort,
    page: params.page,
    page_size: params.page_size,
    paa_id: params.paa_id,
  });

  try {
    return await apiFetch<PaginatedAviListOutput>(`/v1/home/avi-list${query}`);
  } catch (error) {
    if (shouldUseHomeMockFallback()) {
      console.warn("Falling back to local AVI list mock data in development.", error);
      return getMockAviList(params);
    }

    throw error;
  }
}

export function useAviList(params: AviListParams, enabled = true) {
  return useQuery({
    queryKey: [...homeQueryKeys.aviList, params],
    enabled,
    queryFn: () => fetchAviList(params),
  });
}
